import { Button, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import BackButton from '../../../components/common/BackButton'
import CustomContainer from '../../../components/common/CustomContainer'
import ScreenLoadingPlaceholder from '../../../components/ScreenLoadingPlaceholder'
import { useAppDispatch } from '../../../hooks/reduxHooks'
import { RouteConstants } from '../../../navigation/navigation-types'
import { EmailManager } from '../../../services/api/EmailManager'
import { SurveyResponseDto } from '../../../services/api/sharedTypes/Email'
import { displayMessage } from '../../../services/redux/snackbar/snackbar-actions'
import { convertSurveyTypeToString } from '../../../utils/email-utils'
import SurveyAnswers from './SurveyAnswers'
import SurveyDetailSelections from './SurveyDetailSelections'

const SurveyDetail: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { id } = useParams()
    const hash = window.location.hash.substring(1)

    const [loadingData, setLoadingData] = React.useState(false)
    const [survey, setSurvey] = React.useState<SurveyResponseDto>()

    useEffect(() => {
        const fetchData = async () => {
            if (!id) return
            setLoadingData(true)
            try {
                const survey = await EmailManager.getManager().getSurveyAsync(id, hash)
                if (survey) {
                    setSurvey(survey)
                }
            } catch (error) {
                setLoadingData(false)
                return dispatch(displayMessage({ message: error, type: 'error' }))
            }

            setLoadingData(false)
        }

        fetchData()
    }, [setLoadingData])

    if (loadingData) {
        return <ScreenLoadingPlaceholder />
    }

    if (!id || !survey) {
        return (
            <Typography variant='h4' color='error' textAlign='center' marginY={3}>
                Tento dotazník neexistuje
            </Typography>
        )
    }

    return (
        <CustomContainer>
            <Stack justifyContent='space-between' direction='row' alignItems='center'>
                <Stack direction='row' alignItems='center'>
                    <BackButton defaultRoute={RouteConstants.invoices} />
                    <Typography variant='h5' mt={1}>
                        {convertSurveyTypeToString(survey.surveyType)}
                        <Typography
                            variant='body1'
                            color='primary'
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => navigate(RouteConstants.clients + '/' + survey.respondentIdName.id)}
                        >
                            {survey.respondentIdName.name}
                        </Typography>
                    </Typography>
                </Stack>
                <Stack direction='row' spacing={3}>
                    <Button
                        variant='contained'
                        onClick={() => dispatch(displayMessage({ message: 'Funkce není implementována', type: 'error' }))}
                    >
                        Exportovat
                    </Button>
                </Stack>
            </Stack>
            <Stack direction='row' justifyContent='space-between' flexWrap='wrap'>
                <div style={{ width: '700px' }}>
                    <SurveyDetailSelections survey={survey} />
                </div>
                <div style={{ width: '700px' }}>
                    <SurveyAnswers surveyName={convertSurveyTypeToString(survey.surveyType)} answers={survey.answers} />
                </div>
            </Stack>
        </CustomContainer>
    )
}

export default SurveyDetail
